<template>
  <div class="comp-container">
    <div class="title">
      <img src="@saas/pages/assets/images/live-data/statistics.png" alt="" />
      <p>课堂统计</p>
    </div>
    <div class="comp-content">
      <div class="left">
        <div class="echart-box" ref="echartBox"></div>
      </div>
      <div class="right">
        <div
          class="item"
          @click="handleClickMore('attend')"
          :class="{ disabled: !liveNum }"
        >
          <div class="top">
            <div class="block attend"></div>
            <div class="label">出勤</div>
            <div class="more-icon" v-if="liveNum > 0">
              <img src="../../../assets/images/arrow-left.png" alt="" />
            </div>
          </div>
          <div class="data">
            <div class="num">{{ liveNum }}</div>
            <div class="percent">{{ liveNumPercent }}%</div>
          </div>
        </div>
        <div
          class="item"
          @click="handleClickMore('absent')"
          :class="{ disabled: !(totalNum - liveNum) }"
        >
          <div class="top">
            <div class="block absent"></div>
            <div class="label">缺席</div>
            <div class="more-icon" v-if="totalNum - liveNum > 0">
              <img src="../../../assets/images/arrow-left.png" alt="" />
            </div>
          </div>
          <div class="data">
            <div class="num">
              {{ totalNum - liveNum }}
            </div>
            <div class="percent">{{ 100 - liveNumPercent }}%</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="dialogTitle"
      width="590px"
      :close-on-click-modal="false"
      custom-class="student-dialog"
      @close="handleDialogClose"
    >
      <div class="dialog-content">
        <!-- 提示信息 -->
        <div class="dialog-tip">
          {{ dialogTip }}
        </div>

        <!-- 表格头部 -->
        <div class="table-header">
          <div class="header-cell student-name-header">学生昵称</div>
          <div class="header-cell time-header">
            {{ dialogType === "attend" ? "进入时间" : "回放课程" }}
          </div>
          <div class="header-cell course-header">
            {{ dialogType === "attend" ? "退出时间" : "观看时长" }}
          </div>
          <div
            v-if="dialogType === 'absent'"
            class="header-cell progress-header"
          >
            观看进度
          </div>
        </div>

        <!-- 表格内容 -->
        <div class="student-table-body">
          <template v-if="tableData.length">
            <div
              v-for="(item, index) in tableData"
              :key="index"
              class="student-table-row"
            >
              <div class="row-content">
                <div class="student-info">
                  <div
                    class="avatar"
                    :style="{ backgroundColor: item.avatarColor }"
                  >
                    <img v-if="item.avatar" :src="item.avatar" alt="" />
                  </div>
                  <span class="student-name ellipsis">{{ item.nickname }}</span>
                </div>
                <template v-if="dialogType === 'attend'">
                  <div
                    class="data-cell time-cell"
                    :class="{ 'red-color': getIsLate(item.first_join_time) }"
                  >
                    {{ moment(item.first_join_time * 1000).format("HH:mm") }}
                  </div>
                  <div
                    class="data-cell course-cell"
                    :class="{
                      'red-color': getIsLeaveEarly(item.last_quit_time),
                    }"
                  >
                    {{ moment(item.last_quit_time * 1000).format("HH:mm") }}
                  </div>
                </template>
                <template v-if="dialogType === 'absent'">
                  <div
                    class="data-cell time-cell"
                    :class="{ 'red-color': item.playback_online_time === 0 }"
                  >
                    {{ item.playback_online_time === 0 ? "未观看" : "已观看" }}
                  </div>
                  <div class="data-cell course-cell">
                    {{
                      item.playback_online_time === 0
                        ? "-"
                        : formatTimeBySecond(item.playback_online_time)
                    }}
                  </div>
                  <div
                    class="data-cell progress-cell"
                    :class="{
                      'green-color':
                        item.playback_online_time > 0 &&
                        item.playback_online_time === item.playback_total_time,
                    }"
                  >
                    {{
                      item.playback_total_time === 0 ||
                      item.playback_online_time === 0
                        ? "-"
                        : Math.floor(
                            (item.playback_online_time /
                              item.playback_total_time) *
                              100
                          ) + "%"
                    }}
                  </div>
                </template>
              </div>
            </div>
          </template>
          <el-empty
            v-else
            description="暂无内容"
            :image="require('@/assets/img/live-list/empty.png')"
          ></el-empty>
        </div>

        <!-- 分页 -->
        <div class="pagination-container">
          <div class="pagination">
            <button
              class="pagination-btn prev"
              :disabled="currentPage === 1"
              @click="handlePrevPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="上一页"
              />
            </button>
            <div class="pagination-info">
              <span class="current-page">{{ currentPage }}</span>
              <span class="separator">/</span>
              <span class="total-pages">{{ totalPages }}</span>
            </div>
            <button
              class="pagination-btn next"
              :disabled="currentPage === totalPages"
              @click="handleNextPage"
            >
              <img
                src="@saas/pages/assets/images/live-data/arrow-right.svg"
                alt="下一页"
              />
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAbsenceStudentList,
  getAttendanceStudentList,
} from "@saas/server-api/src/live-data";
import { formatTimeBySecond } from "@saas/components/src";
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from "echarts/core";
// 引入柱状图图表，图表后缀都为 Chart
import { PieChart } from "echarts/charts";
// 引入标题，提示框，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import { TooltipComponent, LegendComponent } from "echarts/components";
// 标签自动布局、全局过渡动画等特性
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { LabelLayout } from "echarts/features";
import { CanvasRenderer } from "echarts/renderers";
import { GraphicComponent } from "echarts/components";
import moment from "moment";
// 注册必须的组件
echarts.use([
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout,
  GraphicComponent,
]);
export default {
  props: {
    liveReport: {
      typeof: Object,
      default: () => {},
    },
  },
  data() {
    return {
      myChart: null,
      dialogType: "attend", // attend 出勤 absent缺席
      dialogVisible: false,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,
      noWatchNum: 0,
      moment,
      formatTimeBySecond,
    };
  },
  watch: {
    liveReport: {
      handler(val) {
        if (val && this.myChart) {
          this.setOptions();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize) || 1;
    },
    dialogTitle() {
      return this.dialogType === "attend" ? "出勤同学" : "缺席同学";
    },
    dialogTip() {
      if (this.dialogType === "attend") {
        return `直播时间：${this.handleLiveRange}`;
      } else {
        return `${this.total} 人未参加直播，${this.noWatchNum} 人未查看回放课程`;
      }
    },
    totalNum() {
      return this.liveReport.live_total_num || 0;
    },
    liveNum() {
      return this.liveReport.live_num || 0;
    },
    liveNumPercent() {
      if (this.totalNum === 0) {
        return 0;
      } else {
        return Math.floor((this.liveNum / this.totalNum) * 100);
      }
    },
    handleLiveRange() {
      return `${moment(this.liveReport.room_start_time * 1000).format(
        "HH:mm"
      )}-${moment(this.liveReport.room_end_time * 1000).format("HH:mm")}`;
    },
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    // 是否迟到 直播开始10分钟后算迟到
    getIsLate(date) {
      if (this.liveReport.room_start_time && date) {
        const tenMin = 10 * 60;
        return date - this.liveReport.room_start_time > tenMin;
      } else {
        return false;
      }
    },
    getIsLeaveEarly(date) {
      if (this.liveReport.room_end_time && date) {
        return date < this.liveReport.room_end_time;
      } else {
        return false;
      }
    },
    initEcharts() {
      const dom = this.$refs.echartBox;
      this.myChart = echarts.init(dom);
    },
    setOptions() {
      const totalNum = this.liveReport.live_total_num;
      const attendanceNum = this.liveReport.live_num;
      const absenteesNum = totalNum - attendanceNum;
      var options = {
        tooltip: {
          trigger: "item",
          extraCssText: "z-index: 999;",
        },
        series: [
          {
            // name: "Access From",
            type: "pie",
            radius: ["55%", "90%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
            },
            emphasis: {
              label: {
                show: false,
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: attendanceNum,
                name: "出勤",
                itemStyle: { color: "#5BD58D" },
              },
              {
                value: absenteesNum,
                name: "缺席",
                itemStyle: { color: "#6AA1FF" },
              },
            ],
          },
        ],
        // 核心：使用 graphic 组件固定中心内容
        graphic: {
          elements: [
            // 标题文本
            {
              type: "text",
              left: "center", // 水平居中
              top: "center", // 垂直位置（稍偏上）
              style: {
                text: totalNum,
                fontSize: 36,
                fontWeight: "bold",
                fill: "#333", // 文本颜色
              },
            },
          ],
        },
      };
      this.myChart.setOption(options);
    },
    handleClickMore(type) {
      if (type === "attend" && !this.liveNum) {
        return;
      } else if (type === "absent" && !(this.totalNum - this.liveNum)) {
        return;
      }
      this.dialogType = type;
      this.dialogVisible = true;
      this.currentPage = 1;
      this.loadTableData();
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.tableData = [];
    },
    async loadTableData() {
      try {
        if (this.dialogType === "attend") {
          this.getAttendanceStudentList();
        } else {
          this.getAbsenceStudentList();
        }
      } catch (error) {
        console.error("加载数据失败:", error);
        this.$message.error("加载数据失败");
      }
    },
    // 获取出勤学员
    getAttendanceStudentList() {
      getAttendanceStudentList({
        room_id: this.liveReport.room_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.list || [];
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取缺席学员
    getAbsenceStudentList() {
      getAbsenceStudentList({
        room_id: this.liveReport.room_id,
        page_no: this.currentPage,
        page_size: this.pageSize,
      }).then((res) => {
        if (res.code === 1) {
          this.tableData = res.data.list || [];
          this.total = res.data.total;
          this.noWatchNum = res.data.not_watched_num;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handlePrevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadTableData();
      }
    },
    handleNextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadTableData();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 590px;
  height: 242px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  .title {
    display: flex;
    align-items: center;
    padding: 24px 0 0 24px;
    img {
      width: 24px;
      height: 24px;
    }
    p {
      font-weight: 500;
      font-size: 16px;
      color: #0d1400;
      margin-left: 8px;
    }
  }
  .comp-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 10px;
    .echart-box {
      margin-left: 75px;
      width: 140px;
      height: 140px;
    }
    .right {
      width: 250px;
      margin-right: 50px;
      .item {
        width: 250px;
        height: 70px;
        background: #f7f8fa;
        border-radius: 12px 12px 12px 12px;
        margin-bottom: 12px;
        padding: 8px 8px 8px 16px;
        cursor: pointer;
        pointer-events: all;
        &.disabled {
          pointer-events: none;
        }
        .top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          .block {
            width: 10px;
            height: 10px;
            border-radius: 3px 3px 3px 3px;
            &.absent {
              background: #6aa1ff;
            }
            &.attend {
              background: #5bd58d;
            }
          }
          .label {
            font-weight: 400;
            font-size: 14px;
            color: #515350;
            margin-left: 5px;
            flex: 1;
          }
          .more-icon {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            img {
              transform: rotate(180deg);
              width: 6px;
              height: 9px;
            }
          }
        }
        .data {
          padding-left: 15px;
          margin-top: 6px;
          font-weight: bold;
          font-size: 24px;
          color: #000000;
          display: flex;
          height: 28px;
          line-height: 28px;
          .num {
            width: 87px;
          }
        }
      }
    }
  }
}

// 弹窗样式
::v-deep .student-dialog {
  width: 590px;
  height: 615px;
  background: #ffffff;
  border-radius: 24px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  .el-dialog__header {
    padding: 24px 24px 0 24px;
    border-bottom: none;
    position: relative;
    font-size: 16px;
    .el-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #0d1400;
      height: 22px;
      line-height: 22px;
      display: inline-block;
    }

    .el-dialog__headerbtn {
      top: 24px;
      right: 22px;
      width: 24px;
      height: 24px;
      background: transparent;
      border: none;

      .el-dialog__close {
        color: #4e5969;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding: 0 24px 24px;
    flex: 1;
    overflow: hidden;
  }
}

.dialog-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  .dialog-tip {
    font-size: 14px;
    color: #0d1400;
    margin-top: 8px;
    margin-bottom: 20px;
    line-height: 1.4;
  }

  .table-header {
    display: flex;
    margin-bottom: 16px;

    .header-cell {
      font-size: 12px;
      color: #515350;
      font-weight: 400;
      &.student-name-header {
        width: 240px;
        text-align: left;
      }

      &.time-header {
        flex: 1;
        text-align: right;
      }

      &.course-header {
        flex: 1;
        text-align: right;
      }

      &.progress-header {
        flex: 1;
        text-align: right;
      }
    }
  }

  .student-table-body {
    flex: 1;
    overflow-y: auto;
    .student-table-row {
      margin-bottom: 8px;
      background: #f7f8fa;
      border-radius: 12px;
      &:nth-of-type(even) {
        background: #fff;
      }
      .row-content {
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        width: 100%;
        .student-info {
          display: flex;
          align-items: center;
          gap: 4px;
          width: 240px;
          text-align: left;
          .avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }

          .student-name {
            font-size: 14px;
            color: #000000;
            font-weight: 400;
            line-height: 1.4;
          }
        }

        .data-cell {
          font-size: 14px;
          color: #1d2129;
          text-align: right;
          flex: 1;
          &.time-cell {
            text-align: right;
          }
          &.red-color {
            color: #f53f3f;
          }
          &.green-color {
            color: #00b42a;
          }

          &.course-cell {
            text-align: right;
          }

          &.progress-cell {
            text-align: right;
          }
        }
      }
    }
  }

  .pagination-container {
    display: flex;
    justify-content: right;
    margin-top: 20px;

    .pagination {
      display: flex;
      align-items: center;
      gap: 4px;

      .pagination-btn {
        width: 20px;
        height: 32px;
        border: none;
        border-radius: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.2s;
        padding: 8px 0;

        &:hover:not(:disabled) {
          background: #fff;
        }

        &:disabled {
          background: #fff;
          cursor: not-allowed !important;

          img {
            opacity: 0.5;
          }
        }
        &.prev {
          img {
            transform: rotate(180deg);
          }
        }
        img {
          width: 12px;
          height: 12px;
        }
      }

      .pagination-info {
        display: flex;
        align-items: center;
        padding: 0 8px;
        font-size: 14px;
        color: #1d2129;
        line-height: 1.57;

        .current-page {
          width: 40px;
          height: 28px;
          font-weight: 600;
          font-size: 14px;
          color: #4e5969;
          line-height: 28px;
          background: #f2f3f5;
          border-radius: 2px 2px 2px 2px;
          text-align: center;
        }

        .separator {
          margin: 0 8px;
        }

        .total-pages {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
